module.exports = __webpack_public_path__ + "static/media/session_briiinger_back.476d51df.png";